module.exports = __webpack_public_path__ + "tb-wireframe1.jpg?cadeed9f79e224b0c9a369b40f36bd60";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/tb-wireframe1.jpg
// module id = 240
// module chunks = 0